<!-- Documento nunca enviado a firma -->
@if(firmaCertificada() && ((firmaCertificada()?.Estado ?? null) === null || firmaCertificada()?.Estado  === typesStateSign.CANCELLED)) {
  <form [formGroup]="form" class="grid gap-3">
    <!-- Usuario -->
    <app-lupas 
      formControlName="Usuario" 
      [dataSearhLupa]="dataSearchLupaUsuario"
      (itemSeleccionado)="onUsuarioSeleccionado($event)"
      class="w-full"
    />
    
    <!-- Particpantes -->
    <div class="w-full">
      <label for="Participantes">Correo Firmante</label>
      <input  pInputText formControlName="Participantes" readonly="true" class="!bg-emphasis" fluid="true"/>
      @if(form.get('Participantes')?.invalid && form.get('Participantes')?.touched)  {
        <small class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
          Correo no válido
        </small>
      }
    </div>

    <div class="flex justify-end gap-3 pt-5">
      <p-button
        type="button"
        label="Cancelar"
        icon="icon-cross"
        severity="danger"
        outlined
        (click)="onCerrarModal()"
      />

      <p-button
        type="button"
        label="Aceptar"
        icon="icon-switch"
        severity="success"
        [disabled]="form.invalid"
        outlined
        (click)="onConfirmar()"
      />
    </div>
  </form>
}

<!-- pendiente de firma -->
@if(firmaCertificada() && firmaCertificada()?.Estado  === typesStateSign.OUT_FOR_SIGNATURE) {
  <div class="grid gap-3">
    <div class="flex gap-3">
      <span class="pi pi-send !text-5xl text-primary"></span>
      <p>El documento está pendiente de firma electrónica. ¿Desea verificar su estado?</p>
    </div>    
    <div class="flex justify-end gap-3 pt-5">
      <p-button
        type="button"
        label="Cancelar"
        icon="icon-cross"
        severity="danger"
        outlined
        (click)="onCerrarModal()"
      />
      <p-button
        type="button"
        label="Verificar"
        icon="icon-switch"
        severity="success"
        outlined
        (click)="onVerificar()"
      />
    </div>
  </div>
}

<!-- firmado-->
@if(firmaCertificada() && firmaCertificada()?.Estado  === typesStateSign.SIGNED) {
  <div class="grid gap-3">
    <div class="flex gap-3">
      <span class="pi pi-verified !text-5xl text-primary"></span>
      <p>El documento ya está firmado electrónicamente</p>
    </div>    
    <div class="flex justify-end gap-3 pt-5">
      <p-button
        type="button"
        label="Ok"
        icon="icon-switch"
        severity="success"
        outlined
        (click)="onCerrarModal()"
      />
    </div>
  </div>
}

